import 'app/pages/hosted-checkout/hosted-checkout.scss';
import 'app/pages/hosted-checkout/views/Checkout/styles.scss';
import { CheckoutFrameContext } from 'app/context';
import { PluginsContext } from 'app/features/plugins/state/pluginsContext';
import { PLUGIN_ONLY_METADATA_KEYS } from 'app/pages/hosted-checkout/constants';
import { checkoutRequestType } from 'app/util/constants';
import { replaceTrailingSlash } from 'common/util/string';
import { useContext } from 'react';

export const baseUlrShopify = replaceTrailingSlash(process.env.SHOPIFY_BASE_URL || '');

export const usePlugins = () => {
  const { isFinalizedPayment } = useContext(PluginsContext);
  const { checkoutRequest } = useContext(CheckoutFrameContext);
  const isHostedPayment = checkoutRequest.type === checkoutRequestType.hostedPayment;
  const orderId = checkoutRequest.orders[0]?.apiOrderId;
  const isShopify = checkoutRequest.orderTemplate.metadata?.find((item: any) =>
    PLUGIN_ONLY_METADATA_KEYS.includes(item.key),
  );
  const showButtonCancel = isShopify && isHostedPayment && !isFinalizedPayment;

  const onCancel = () => {
    window.location.href = `${baseUlrShopify}api/checkout/cancel?order_id=${orderId}`;
  };

  return {
    onCancel,
    showButtonCancel,
    isHostedPayment,
    isShopify,
  };
};
